<nav class="navbar top-navbar p-0">
    <div class="container-fluid">
        <div class="navbar-menu-wrapper d-flex align-items-center justify-content-between">
            <!-- <button id="sidebarToggleTop" class="btn btn-link rounded-circle mr-3 burger-icon d-md-none"
                (click)="toggleSidebar()">
                <i class="mdi mdi-menu"></i>
            </button> -->
            <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                <a class="navbar-brand brand-logo" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/dashboard']" (click)="collapseSidebar()">
                    <img src="assets/images/{{BRAND.BRAND_LOGO}}" alt="logo" />
                </a>
            </div>
            <ul class="navbar-nav navbar-nav-right">
                <li class="nav-item">
                    <a class="btn btn-sm dark-btn" href="javascript:void(0)" data-toggle="modal" data-target="#myModal">
                        {{breadCrumService.partyNameSelected}}
                        <i class="fas fa-angle-down ml-2 mr-0"></i>
                    </a>
                </li>
                <li class="nav-item dropdown hover-dropdown" *ngIf="USER_TYPE && USER_TYPE === 'CUSTOMER'">
                    <span class="nav-link count-indicator d-flex align-items-center justify-content-center"
                        id="notificationDropdown" [attr.aria-expanded]="true">
                        <i class="mdi mdi-bell mx-0"></i>
                        <span class="count"
                            *ngIf="(NO_OF_PI_APPROVAL + NO_OF_ARTWORK_APPROVAL) !== 0">{{(NO_OF_PI_APPROVAL +
                            NO_OF_ARTWORK_APPROVAL)}}</span>
                    </span>
                    <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
                        aria-labelledby="notificationDropdown">
                        <p class="mb-0 font-weight-normal float-left dropdown-header">Notifications</p>
                        <a class="dropdown-item preview-item" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/order/salesOrder']"
                            *ngIf="NO_OF_PI_APPROVAL > 0">
                            <img src="assets/icons/Approve_PI.svg" width="36" height="36" alt="PI" />
                            <div class="preview-item-content">
                                <h6 class="preview-subject font-weight-normal">PI Approvals</h6>
                                <p class="font-weight-light small-text mb-0 text-muted">
                                    {{NO_OF_PI_APPROVAL}} {{NO_OF_PI_APPROVAL > 1 ? 'Items': 'Item'}}
                                </p>
                            </div>
                        </a>
                        <a class="dropdown-item preview-item" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/packing/approveArtwork']"
                            *ngIf="NO_OF_ARTWORK_APPROVAL > 0">
                            <img src="assets/icons/Artwork.svg" width="36" height="36" alt="Artwork" />
                            <div class="preview-item-content">
                                <h6 class="preview-subject font-weight-normal">Artwork Approvals</h6>
                                <p class="font-weight-light small-text mb-0 text-muted">
                                    {{NO_OF_ARTWORK_APPROVAL}} {{NO_OF_ARTWORK_APPROVAL > 1 ? 'Items': 'Item'}}
                                </p>
                            </div>
                        </a>
                        <a class="dropdown-item preview-item"
                            *ngIf="(NO_OF_PI_APPROVAL + NO_OF_ARTWORK_APPROVAL) === 0">
                            <div class="preview-item-content">
                                <p class="font-weight-light small-text mb-0 text-muted">
                                    No Notifications Available
                                </p>
                            </div>
                        </a>
                    </div>
                </li>

                <li class="nav-item dropdown" style="width: 160px;">
                    <a class="btn btn-sm dark-btn d-flex" href="#" role="button" style="width: 100%;"
                        data-toggle="dropdown" id="profileDropdown" aria-haspopup="true" aria-expanded="false">
                        <span style="width: 90%; overflow: hidden;text-overflow: ellipsis;">{{userName}}</span>
                        <i style="width: 10%;" class="fas fa-angle-down ml-2 mr-0"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right navbar-dropdown" style="width: 100%;"
                        aria-labelledby="profileDropdown">
                        <a class="dropdown-item customer-item" [routerLink]="['/' + BRAND.BASE_ROUTE+ '/changePassword']">
                            <i class="mdi mdi-settings text-primary"></i>
                            Change Password
                        </a>
                        <a *ngIf="ALLOW_PORTAL_SWITCH" class="dropdown-item customer-item"
                           [href]="OTHER_BRAND.BRAND_HOST + '/auth/login?switchPortalContext=' + token">
                            <i class="mdi mdi-information text-primary"></i>
                            {{OTHER_BRAND.BRAND_PORTAL_NAME}}
                        </a>
                        <a class="dropdown-item customer-item" (click)="downloadUserManual()">
                            <i class="mdi mdi-information text-primary"></i>
                            User Manual
                        </a>
                        <a class="dropdown-item customer-item" (click)="logout()">
                            <i class="mdi mdi-logout text-primary"></i>
                            Logout
                        </a>
                    </div>
                </li>
            </ul>
            <button class="navbar-toggler navbar-toggler-right d-md-none align-self-center" type="button"
                data-toggle="horizontal-menu-toggle" (click)="collapseSecondHeader()">
                <span class="mdi mdi-menu"></span>
            </button>
        </div>
    </div>
</nav>
<div class="modal fade" id="myModal">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Select</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="form-group">
                        <label>Select Party</label>
                        <input class="form-control js-example-basic-single" list="selectParty"
                            (input)="setParty($event.target.value)" id="documentNo">
                        <datalist id="selectParty">
                            <select>
                                <option *ngFor="let item of breadCrumService.partyList" [value]='item.PARTY_NAME'>
                                    {{item.PARTY_NAME}}</option>
                            </select>
                        </datalist>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> &nbsp;
                <button type="button" class="btn btn-primary" (click)="confirmParty()" data-dismiss="modal"
                    [class.btn-secondary]="!party" [class.btn-primary]="party" [disabled]="!party">Confirm
                    Party</button>
            </div>
        </div>
    </div>
</div>
